// extracted by mini-css-extract-plugin
export var divider = "_np-0";
export var systemMessage = "_np-1";
export var systemMessageWrapper = "_np-2";